interface GoogleOTPData {
  subscription_type: string;
  product_slug: string;
}

const GOOGLE_OTP_STORAGE_KEY = 'google_otp_data';

/**
 * Gets the subscription type from localStorage for Google OTP flow
 * @returns The subscription_type value or null if not found/invalid
 */
export const getSubscriptionType = (): string | null => {
  const storedData = localStorage.getItem(GOOGLE_OTP_STORAGE_KEY);
  if (!storedData) return null;

  try {
    const otpData: GoogleOTPData = JSON.parse(storedData);
    return otpData.subscription_type;
  } catch {
    // Invalid data, return null
    return null;
  }
};

/**
 * Checks if the current subscription type is Google OTP
 * @returns true if subscription_type is 'otp'
 */
export const isGoogleOTP = (): boolean => {
  return getSubscriptionType() === 'otp';
};

/**
 * Clears Google OTP data from localStorage
 */
export const clearGoogleOTPData = (): void => {
  localStorage.removeItem(GOOGLE_OTP_STORAGE_KEY);
};
